const getters = {
  lang: state => state.home.lang,
  urlApi: state => state.home.urlApi,
  banner: state => state.home.banner,
  menu: state => state.home.menu,
  menuEn: state => state.home.menuEn,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js